export default __webpack_public_path__ + "static/media/thumbnail_blog_13.66c91225.jpg";